import { render, staticRenderFns } from "./ssohome.vue?vue&type=template&id=098dd372"
import script from "./ssohome.vue?vue&type=script&lang=js"
export * from "./ssohome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports